import { computed } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

type DeliveryOption = {
  latestArrivalDate: string
}

export const useDeliveryBeforeChristmas = (
  shipping?:
    | NonNullable<GetPickersResponse['selectedOffer']>['shipping']
    | {
        free?: DeliveryOption
        express?: DeliveryOption
      },
) => {
  const deliveryBeforeChristmasTimeFrame = {
    from: Date.parse(`01 Dec ${new Date().getFullYear()} 00:00:00 UTC`),
    to: Date.parse(`23 Dec ${new Date().getFullYear()} 23:59:59 UTC`),
  }

  const isChristmasTime = computed(() => {
    return (
      Date.now() > deliveryBeforeChristmasTimeFrame.from &&
      Date.now() < deliveryBeforeChristmasTimeFrame.to
    )
  })

  const isStandardDeliveryBeforeChristmas = computed(() => {
    return (
      (isChristmasTime.value &&
        shipping?.free &&
        new Date(shipping.free.latestArrivalDate).valueOf() <
          deliveryBeforeChristmasTimeFrame.to) ??
      false
    )
  })

  const isExpressDeliveryBeforeChristmas = computed(() => {
    return (
      (isChristmasTime.value &&
        shipping?.express &&
        new Date(shipping.express.latestArrivalDate).valueOf() <
          deliveryBeforeChristmasTimeFrame.to) ??
      false
    )
  })

  const hasDeliveryBeforeChristmas = computed(() => {
    return (
      isStandardDeliveryBeforeChristmas.value ||
      isExpressDeliveryBeforeChristmas.value
    )
  })

  return {
    isStandardDeliveryBeforeChristmas,
    isExpressDeliveryBeforeChristmas,
    hasDeliveryBeforeChristmas,
    isChristmasTime,
  }
}
